/* eslint-disable max-len */
import BaseDataTransformer from './base-data-transformer/base-data-transformer';
import DatagridDataTransformer from './data-grid-data-transformer/data-grid-data-transformer';
import GenericDataTransformer from './generic-data-transformer/generic-data-transformer';
import NamedChartDataToHighchartsDataTransformer from './named-chartdata-to-highcharts-data-transformer/named-chartdata-to-highcharts-data-transformer';
import NamedChartDataToKeyFigureTransformer from './named-chartdata-to-keyfigure-data-transformer/named-chartdata-to-keyfigure-data-transformer';
import PlainChartDataToGroupToHighchartsTransformer from './plain-chartdata-to-group-to-highcharts-transformer/plain-chartdata-to-group-to-highcharts-transformer';
import PlainChartDataToGroupTransformer from './plain-chartdata-to-group-transformer/plain-chartdata-to-group-transformer';
import InvoiceServiceDataTransformer from './invoice-service-data-transformer/invoice-service-data-transformer';

const DataVisualizers = new Map([
  ['BaseDataTransformer', () => new BaseDataTransformer()],
  ['DataGridDataTransformer', () => new DatagridDataTransformer()],
  ['GenericDataTransformer', () => new GenericDataTransformer()],
  ['NamedChartDataToHighchartsDataTransformer', () => new NamedChartDataToHighchartsDataTransformer()],
  ['NamedChartDataToKeyFigureTransformer', () => new NamedChartDataToKeyFigureTransformer()],
  ['PlainChartDataToGroupToHighchartsTransformer', () => new PlainChartDataToGroupToHighchartsTransformer()],
  ['PlainChartDataToGroupTransformer', () => new PlainChartDataToGroupTransformer()],
  ['InvoiceServiceDataTransformer', () => new InvoiceServiceDataTransformer()],
]);

export default DataVisualizers;
